module.exports = __webpack_public_path__ + "static/media/p7.49353312.jpg";